import rootService from 'core/services.root';

export default rootService({
    cloneParticipants: ['POST', '/campaign/:id/invite/from'],
    fetchCampaign: ['GET', '/campaign/:id'],
    fetchCampaignParticipants: ['GET', '/campaign/:id/participants?limit=15'],
    fetchCampaignParticipantsStatus: ['GET', '/campaign/:id/participants/total'],
    fetchCampaigns: ['GET', '/campaign/paginated'],
    fetchDonation: ['GET', '/patient/extended/donation/:id'],
    fetchTraining: ['GET', '/patient/extended/training/:id'],
    fetchVaccination: ['GET', '/patient/extended/vaccination/:id'],
    inviteParticipants: ['POST', '/campaign/:id/invite'],
    postCampaign: ['POST', '/campaign/store'],
    postDonation: ['POST', '/campaign/:participant_id/donation'],
    postTraining: ['POST', '/campaign/:participant_id/training'],
    postVaccination: ['POST', '/campaign/:participant_id/vaccination'],
    putCampaign: ['PUT', '/campaign/update/:id'],
    putDonation: ['PUT', '/campaign/donation/:donation_id/update'],
    putParticipantStatus: ['PUT', '/campaign/change-status/:participant_id'],
    putTraining: ['PUT', '/campaign/training/:training_id/update'],
    putVaccination: ['PUT', '/campaign/vaccination/:vaccination_id/update']
});
